interface ImageSkeletonProps {
	width?: number | string;
	height?: number | string;
	className?: string;
}

/**
 * Skeleton component that displays during image loading
 * Shows a pulsating animation to indicate loading state
 */
export const ImageSkeleton = ({
	width,
	height,
	className = "",
}: ImageSkeletonProps) => {
	// Helper function to format dimension values
	const formatDimension = (value: number | string | undefined): string => {
		if (value === undefined) return "100%";
		if (typeof value === "string" && /[a-z%]$/i.test(value)) return value;

		return `${value}px`;
	};

	return (
		<div
			className={`bg-gray-600 animate-pulse rounded ${className}`}
			style={{
				width: formatDimension(width),
				height: formatDimension(height),
				minWidth: "20px",
				minHeight: "20px",
			}}
			aria-hidden="true"
		/>
	);
};
